const tileRowSize = (width) => {
  if (width < 1030) {
    return 2;
  }

  if (width < 1320) {
    return 3;
  }

  return 4;

};

export default tileRowSize;
